<template>
  <div class="store-info-page">
    <!-- 背景圖片 + 店家名稱區域 -->
    <div class="store-hero-section">
      <!-- 透明導航列（疊在背景圖片上） -->
      <div class="transparent-navbar">
        <backButton />
      </div>
      
      <!-- 背景圖片 -->
      <div class="hero-background">
        <img 
          :src="storeBackgroundImage" 
          alt="店家背景" 
          class="background-image"
        />
        <!-- 漸層遮罩 -->
        <div class="gradient-overlay"></div>
      </div>
      
      <!-- 店家名稱 -->
      <div class="store-name-container">
        <h2 class="store-name">{{ storeName }}</h2>
      </div>
    </div>
    
    <!-- 主要內容區域 -->
    <div class="main-content">
      <!-- 店家公告卡片 -->
      <storeNoticeCard @click="showManualNotice = true" />
      
      <!-- 店家簡介 -->
      <div v-if="storeDescription" class="store-description">
        <div class="description-text" v-html="sanitizedDescription"></div>
      </div>
      
      <!-- 營業資訊卡片 -->
      <storeInfoDetail />
      
      <!-- 社群媒體連結 -->
      <storeSocialLinks />
      
      <!-- 加入 VIP 按鈕 -->
      <!-- <button 
        class="vip-button" 
        v-if="!isStoreMember"
        @click="isLogin ? joinMember() : login()"
      >
        加入店家VIP
      </button>
      <button 
        class="vip-button" 
        v-else 
        @click="toMemberPage"
      >
        VIP會員卡
      </button> -->
    </div>
    
    <!-- 手動控制的公告彈窗（點擊卡片顯示） -->
    <storeNoticePopup 
      manual-mode 
      :show="showManualNotice" 
      @close="showManualNotice = false" 
    />
  </div>
</template>

<script>
import storeInfoDetail from "../components/store/storeInfoDetail.vue";
import storeNoticeCard from "../components/store/storeNoticeCard.vue";
import storeSocialLinks from "../components/store/storeSocialLinks.vue";
import storeNoticePopup from "../components/general/storeNoticePopup.vue";
import backButton from "../components/backButton.vue";
import commonUtils from "@/utils/common.utils";
import apiData from "@/services/apiData";
import { sanitizeHtml } from "@/utils/htmlSanitizer.utils";
import {
  mapGetters,
  mapState
} from 'vuex';

export default {
  components: {
    backButton,
    storeInfoDetail,
    storeNoticeCard,
    storeSocialLinks,
    storeNoticePopup
  },
  
  data() {
    return {
      showManualNotice: false  // 控制手動點擊的公告彈窗
    }
  },
  
  computed: {
    ...mapGetters('basic', {
      storeName: 'storeName',
      storeDescription: 'storeDescription',
      storeInfoImageUrl: 'storeInfoImageUrl'
    }),
    ...mapGetters('userData', {
      isLogin: 'isLogin',
      isStoreMember: 'isStoreMember',
      storeMemberUuid: 'storeMemberUuid',
      storeCode: 'storeCode'
    }),
    ...mapState('userData', {
      storeData: 'storeData'
    }),
    currentStore() {
      return this.$store.state.basic.currentStore
    },
    // 店家背景圖片（優先使用動態載入的圖片）
    storeBackgroundImage() {
      // 1. 優先使用從 API 動態載入的店家資訊圖片
      if (this.storeInfoImageUrl) {
        return this.storeInfoImageUrl;
      }
      
      // 2. 使用預設圖片
      return require('@/assets/store/store_banner_background.jpg');
    },
    
    // 淨化後的店家簡介（支援 HTML 格式）
    sanitizedDescription() {
      if (!this.storeDescription) return ''
      
      try {
        // 使用 htmlSanitizer.utils.js 的 sanitizeHtml 函數
        return sanitizeHtml(this.storeDescription)
      } catch (error) {
        console.error('店家簡介 HTML 淨化失敗:', error)
        
        // 錯誤處理：回退到純文字模式
        return this.storeDescription.replace(/<[^>]*>/g, '')
      }
    }
  },
  
  watch: {
    isLogin(state) {
      if (state && !this.isStoreMember) {
        this.joinMember()
      } else if (state && this.isStoreMember && this.storeMemberUuid) {
        this.toMemberPage()
      }
    }
  },
  
  methods: {
    toMemberPage() {
      this.$router.push({
        path: `/${this.currentStore}`,
      });
    },
    async joinMember() {
      try {
        commonUtils.createLoading("資料讀取中", "請稍後");
        await this.$store.dispatch('userData/joinMember')
        commonUtils.closeLoading()
        commonUtils.delay(500)
        commonUtils.createToast("success", "加入成功")
      } catch (e) {
        console.log('join member error', e)
        commonUtils.closeLoading()
        commonUtils.delay(500)
        commonUtils.createToast("error", `${e}`)
      }
    },
    login() {
      let data = new apiData();
      data.store = this.storeCode;
      this.$store.dispatch('line/login', data)
    }
  },
};
</script>

<style lang="scss" scoped>
.store-info-page {
  position: relative;
  min-height: 100vh;
  background: linear-gradient(
    180deg,
    #F0F0F0 0%,
    #8A8A8A 100%
  );
}

/* 背景圖片 + 店家名稱區域 */
.store-hero-section {
  position: relative;
  width: 100%;
  height: 330px;
  overflow: hidden;
}

/* 透明導航列 */
.transparent-navbar {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  z-index: 10;
}

.hero-background {
  position: relative;
  width: 100%;
  height: 100%;
}

.background-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.gradient-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    180deg,
    rgba(4, 4, 4, 0.1) 0%,
    rgba(1, 1, 1, 0.2) 100%
  );
}

.store-name-container {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}

.store-name {
  font-size: 22px;
  font-weight: 600;
  color: #FFFFFF;
  margin: 0;
  text-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
}

/* 主要內容區域 */
.main-content {
  position: relative;
  background: #FFFFFF;
  border-radius: 30px 30px 0 0;
  margin-top: -10px;
  padding-bottom: 30px;
  padding-top: 10px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  min-height: calc(100vh - 300px);
}

/* 店家簡介 */
.store-description {
  padding: 20px 16px;
  background: #FFFFFF;
}

.description-text {
  font-size: 16px;
  line-height: 24px;
  color: #666666;
  margin: 0;
  word-break: break-word;
  
  /* 支援 HTML 標籤樣式 */
  /* 段落 */
  :deep(p) {
    margin: 0 0 12px 0 !important;
    &:last-child { 
      margin-bottom: 0; 
    }
  }
  
  /* 文字格式 */
  strong, b { 
    font-weight: 600; 
    color: #333333; 
  }
  
  em, i { 
    font-style: italic; 
  }
  
  u { 
    text-decoration: underline; 
  }
  
  /* 換行 */
  br {
    display: block;
    content: "";
    margin: 4px 0;
  }
  
  /* Span 標籤（支援 inline style） */
  span {
    /* 繼承父元素樣式，允許 style 屬性覆蓋 */
    display: inline;
  }
}

/* VIP 按鈕 */
.vip-button {
  width: calc(100% - 32px);
  margin: 30px 16px;
  padding: 12px;
  background: #FD5001;
  color: #FFFFFF;
  font-size: 18px;
  font-weight: 600;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s ease;
}

.vip-button:hover {
  background: #E64801;
}

.vip-button:active {
  background: #CC4001;
}
</style>
